import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../home/components/Footer";
import { projects } from "../../mocks/homeData";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function ProjectsPage() {
  usePageMeta({
    title: "Projeler | Hangar Muhendislik",
    description:
      "Tamamlanan endustriyel yapi ve celik konstruksiyon projeleri: fabrika, depo, hangar ve tesis referanslari.",
  });

  return (
    <div className="font-body antialiased">
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden bg-navy">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/0b10cde4-79b3-4834-8025-f6c37e12124b_img4.jpeg?v=001a87ce4f8b1a4e7814662587e1c32d"
              alt="Proje Arkaplan"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/50 to-navy/70" />
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 text-center">
            <div className="inline-block w-12 h-1 rounded-full bg-copper mb-6" />
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4">
              Tamamlanan Projelerimiz
            </h1>
            <p className="font-body text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              250'den fazla başarıyla tamamlanan proje ile Türkiye'nin dört bir yanında referanslar oluşturduk.
            </p>
          </div>
        </section>

        {/* Projects Grid */}
        <section className="bg-white py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {projects.map((project) => (
                <div
                  key={project.id}
                  className="group bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-copper/20 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl"
                >
                  <div className="relative h-56 md:h-64 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                      <span className="inline-block bg-copper/90 text-white font-body text-xs font-medium px-3 py-1 rounded-full mb-2">
                        {project.year}
                      </span>
                      <h3 className="font-heading font-bold text-lg md:text-xl text-white mb-1">
                        {project.name}
                      </h3>
                      <p className="font-body text-xs text-white/80">
                        {project.reference}
                      </p>
                    </div>
                  </div>
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 text-gray-500 mb-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-map-pin-line" />
                      </div>
                      <span className="font-body text-sm">{project.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-500 mb-4">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-building-line" />
                      </div>
                      <span className="font-body text-sm">{project.reference}</span>
                    </div>
                    <Link
                      to="/iletisim"
                      className="inline-flex items-center gap-2 font-body text-sm font-medium text-copper hover:text-copper-dark transition-colors group/link"
                    >
                      Benzer Proje İçin Teklif Al
                      <div className="w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform">
                        <i className="ri-arrow-right-line" />
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Banner */}
        <section className="bg-navy py-16 md:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 text-center">
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">250+</div>
                <div className="font-body text-sm text-white/70">Tamamlanan Proje</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">150+</div>
                <div className="font-body text-sm text-white/70">Mutlu Müşteri</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">20+</div>
                <div className="font-body text-sm text-white/70">Uzman Ekip</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">15+</div>
                <div className="font-body text-sm text-white/70">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </section>

        {/* Referanslar */}
        <section className="bg-stone-50 py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-12 md:mb-16">
              <div className="inline-block w-12 h-1 rounded-full bg-copper mb-4" />
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4">
                Referanslarımız
              </h2>
              <p className="font-body text-base text-gray-600 max-w-2xl mx-auto">
                Türkiye'nin önde gelen firmalarına güvenilir çelik konstrüksiyon çözümleri sunduk.
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {references.map((ref) => (
                <div
                  key={ref}
                  className="group bg-white rounded-lg border border-gray-100 p-5 md:p-6 flex flex-col items-center justify-center text-center hover:border-copper/30 hover:-translate-y-1 transition-all duration-300 cursor-default"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-copper/10 flex items-center justify-center mb-3 md:mb-4 group-hover:bg-copper/20 transition-colors duration-300">
                    <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-copper">
                      <i className="ri-building-4-line text-xl md:text-2xl" />
                    </div>
                  </div>
                  <h3 className="font-heading font-semibold text-sm md:text-base text-navy leading-snug">
                    {ref}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

const references = [
  "Alyon Mühendislik",
  "Ezgü Geri Dönüşüm",
  "Orkun Yapı",
  "Hortum Marketler",
  "Teksan Hidrolik",
  "Betonel",
  "Çilesizler Mermer",
  "Kaleliler Civata",
  "Başak Matbaa",
  "Aksiyon Global",
  "Limmer Beton",
];
